import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { FamilyProfilesProvider } from './components/FamilyProfiles';
import { useBookingStepScrollReset } from './useBookingStepScrollReset';
import './PortalLayout.css';
import './BookingFlowBackground.css';
import './BookingFlowLayout.css';
import './BookingFlowMobile.css';

export default function App() {
  const { pathname } = useLocation();
  useBookingStepScrollReset();
  // Styling opt-in only; shared new-booking and administrator views keep their frame.
  const usePatientAppointmentMobileLayout =
    !['modeAdmin', 'modeRoot'].includes(localStorage.getItem('sidebarMode') ?? '') &&
    (['/cancellation', '/cancellation-done', '/move-conf'].includes(pathname) ||
      (['/date-time-entry', '/appointment-summary'].includes(pathname) &&
        Boolean(localStorage.getItem('selectedAppointmentId')?.trim())));
  const patientAppointmentMobileClass = usePatientAppointmentMobileLayout ? ' portal-appointment-mobile' : '';
  if (pathname === '/directions') {
    return <div className="directions-page-layout"><Outlet /></div>;
  }
  if (pathname === '/cancellation' || pathname === '/cancellation-done') {
    return <div className={`cancellation-page-layout${patientAppointmentMobileClass}`}><Outlet /></div>;
  }

  const isBookingFlow = [
    '/procedures',
    '/emergency',
    '/practitioners',
    '/date-time-entry',
    '/new-patient-data',
    '/appointment-summary',
    '/appointment-booked',
    '/move-conf',
  ].includes(pathname);
  const showSidebar = ![
    '/date-time-entry',
    '/procedures',
    '/emergency',
    '/practitioners',
    '/new-patient-data',
    '/appointment-summary',
    '/appointment-booked',
    '/move-conf',
    '/registration-done',
  ].includes(pathname);
  const useSharedPageLayout = showSidebar && pathname !== '/dashboard';

  const content = (
    <>
      <div className={`flex items-stretch gap-6 px-6 py-8${useSharedPageLayout ? ' portal-layout--shared' : ''}${isBookingFlow ? ' portal-booking-flow' : ''}${patientAppointmentMobileClass}`}>
        {showSidebar && <Sidebar />}
        <div className="portal-content flex-1">
          {useSharedPageLayout ? (
            <div className="portal-page-layout"><Outlet /></div>
          ) : <Outlet />}
        </div>
      </div>
    </>
  );
  return localStorage.getItem('sidebarMode') === 'modePatient'
    ? <FamilyProfilesProvider>{content}</FamilyProfilesProvider> : content;
}
